import PropTypes from "prop-types"
import { map } from "lodash"

export default function CompareItemSubHeader({ additionalHeaders }) {
  return <div>
    {map(additionalHeaders, (text, i) => <div key={i} data-ckey={i} data-test-class="compare-item-sub-header">{text}</div>)}
  </div>
}

CompareItemSubHeader.propTypes = {
  additionalHeaders: PropTypes.arrayOf(PropTypes.string),
}
